import { Core } from '../../Constants';
export function Mixin(Base) {
    return class SupportedProperty extends Base {
        get readable() {
            const readable = this.get(Core.Vocab('readable'));
            if (typeof readable === 'boolean') {
                return readable;
            }
            return true;
        }
        get writable() {
            const writable = this.get(Core.Vocab('writeable'));
            if (typeof writable === 'boolean') {
                return writable;
            }
            return true;
        }
        get required() {
            const required = this.get(Core.Vocab('required'));
            if (typeof required === 'boolean') {
                return required;
            }
            return false;
        }
        get property() {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return this.get(Core.Vocab('property'), { strict: true });
        }
    };
}
export const shouldApply = (res) => res.types.contains(Core.Vocab('SupportedProperty'));
//# sourceMappingURL=SupportedProperty.js.map